(ns serv-ui.page
  "What every page is drawn in: a title, and what is loading or failed."
  (:require-macros [kc.core :refer [def-ui $]])
  (:require [kc.spa :as spa]
            [serv-ui.mui :as mui :refer [sx]]))

(defn goto! [page params]
  (spa/goto-location! {:page page :params params}))

(def-ui Page [top overline title subtitle ***]
  ($ mui/Box {:sx (sx {:maxWidth "60rem" :margin "0 auto" :minWidth 0
                       :overflowWrap "anywhere"
                       :padding "1.5rem 1rem 6rem 1rem"})}
     top
     (when overline
       ($ mui/Typography {:variant "overline" :sx (sx {:color "text.secondary" :display "block"
                                                       :lineHeight 1.6 :overflowWrap "anywhere"})}
          overline))
     (when title
       ($ mui/Typography {:variant "h5" :sx (sx {:mb (if subtitle 0 2)
                                                :overflowWrap "anywhere"})}
          title))
     (when subtitle
       ($ mui/Typography {:sx (sx {:color "text.secondary" :mb 2
                                   :overflowWrap "anywhere"})}
          subtitle))
     ***))

(def-ui Loading [load]
  (cond
    (:error load) ($ mui/Alert {:severity "error" :variant "outlined"
                                :action ($ mui/Button {:color "inherit" :size "small"
                                                       :onClick (fn [_] ((:reload load)))}
                                           "Retry")}
                     (:error load))
    :else         ($ mui/Box {:sx (sx {:display "flex" :justifyContent "center" :padding "2rem"})}
                     ($ mui/CircularProgress {:size 28}))))
